import { render, staticRenderFns } from "./auth-popup.vue?vue&type=template&id=5180c62b"
import script from "./auth-popup.vue?vue&type=script&lang=js"
export * from "./auth-popup.vue?vue&type=script&lang=js"
import style0 from "./auth-popup.vue?vue&type=style&index=0&id=5180c62b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports